import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Egy backend-relatív zászló/kép útvonal abszolúttá tétele (dev + éles egyaránt működik). */
export function assetUrl(path?: string | null): string | undefined {
  if (!path) return undefined;
  if (/^https?:\/\//i.test(path)) return path;
  return path.startsWith("/") ? path : `/flags/${path}`;
}

/** Rövid magyar dátum-formázás (UTC → helyi). */
export function formatMatchDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString("hu-HU", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
